// Generated by scripts/generate-icons.ts
/* eslint-disable */

// This file is auto-generated. Do not edit manually.
import React from 'react';
import { BaseIcon } from '../src/components/BaseIcon';
import type { IconDefinition, IconPath } from '../src/types/IconData.types';

const iconData: IconDefinition = {
  name: "Heart",
  viewBox: "0 0 20 20",
  paths: [
    {
      d: "M10 5.855S8.515 4 6.61 4a3.68 3.68 0 0 0-3.27 2.136 3.69 3.69 0 0 0 .488 3.877c.464.601 5.563 5.73 5.563 5.73A.86.86 0 0 0 10 16a.86.86 0 0 0 .6-.258s5.108-5.154 5.572-5.73A3.686 3.686 0 0 0 13.39 4C11.486 4 10 5.855 10 5.855"
    }
  ]
};

export const HeartIcon: React.FC<React.SVGProps<SVGSVGElement> & { iconPathClassName?: string }> = (props) => {
  return <BaseIcon icon={iconData} {...props} />;
};
